webpackJsonp([12],{

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(106);
module.exports = __webpack_require__(0).Object.assign;


/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(4);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(107) });


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(69);
var gOPS = __webpack_require__(163);
var pIE = __webpack_require__(149);
var toObject = __webpack_require__(30);
var IObject = __webpack_require__(180);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(70)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(109), __esModule: true };

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53);
__webpack_require__(28);
module.exports = __webpack_require__(110);


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(18);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(20);
var ITERATOR = __webpack_require__(10)('iterator');
var Iterators = __webpack_require__(40);
module.exports = __webpack_require__(0).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(112), __esModule: true };

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(53);
__webpack_require__(28);
module.exports = __webpack_require__(113);


/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(14);
var get = __webpack_require__(26);
module.exports = __webpack_require__(0).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function processSelectItem(container, menu, menuItem, seletedItem) {
  var flag = menuItem.getAttribute("data-flag");
  var code = menuItem.getAttribute("data-phone-code");
  seletedItem.querySelector(".selected--flag").innerHTML = "<img class=\"sprite_flags_" + flag.toLocaleLowerCase() + "\">";
  seletedItem.querySelector(".selected--code").textContent = code;
  container.parentNode.querySelector("input[name='enquiry[phone_country_code]']").setAttribute('value', flag.toLocaleUpperCase());
  container.querySelector('input.phone').focus();
  menu.classList.add("hide");
}

function handleMenuClick(container, menu, seletedItem) {
  menu.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    var liTag = e.target.closest("li");
    processSelectItem(container, menu, liTag, seletedItem);
  });
}

function handleDropdownClick(dropdown, menu) {
  dropdown.addEventListener("click", function () {
    menu.classList.toggle("hide");
  });
}

function handleOutSideClick(dropdown) {
  document.body.addEventListener("click", function (e) {
    if (!dropdown.contains(e.target)) {
      var menu = dropdown.querySelector('ul');
      menu.classList.add("hide");
    }
  });
}

function initDropdownEvents(containers) {
  containers.forEach(function (container) {
    var dropdown = container.querySelector(".country-dropdown");
    var menu = dropdown.querySelector("ul");
    var selectedItem = dropdown.querySelector(".country-dropdown__seleted");

    handleDropdownClick(dropdown, menu);
    handleMenuClick(container, menu, selectedItem);
    handleOutSideClick(container);
  });
}

exports.default = initDropdownEvents;

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(console) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperties = __webpack_require__(61);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _defineProperty = __webpack_require__(21);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */

var STRINGS = {
  finish: "Adding missing $type mark for `$src`, measure will be to window.onload"
};

/**
 * @private
 * Replaces placeholders in message string with values.
 *
 * @param {Object} arg
 * @param {String} arg.string - The message string to use
 * @param {String} arg.src - The source for the message string
 * @param {String} arg.type - The type for the message string
 *
 * @returns {String}
 */
function stringReplace(_ref) {
  var string = _ref.string,
      src = _ref.src,
      type = _ref.type;

  var source = STRINGS[string];

  return source ? source.replace("$src", src).replace("$type", type) : string;
}

/**
 * @private
 * Writes out to the console the grouped marks or measures that have been
 * created in the instance.
 *
 * @param {string} type - Type of entries to use ("marks" / "measures")
 */
function debugReport(type) {
  var self = this;
  var entries = self[type] || [];

  if (!entries.length) {
    console.error("No " + type + " found");
    return;
  }

  console.group(self.src + ": " + type);
  entries.forEach(function (entry) {
    var time = type === "marks" ? entry.startTime : entry.duration;

    console.info(entry.name + ": " + time + "ms");
  });
  console.groupEnd();
}

/**
 * @private
 * Gets the latest entry for the supplied source and type.
 *
 * @param {string} src The source
 * @param {string} type The type of entry to use
 */
function getLatestEntry(src, type) {
  return window.performance.getEntriesByType(type).reverse().find(function (entry) {
    return entry.name.substr(0, src.length) === src;
  });
}

/**
 * @private
 * Gets the prefix for marks and measures from the supplied source and optional method.
 *
 * @param {string} src - The source
 * @param {stirng=} method - Name of method (optional)
 */
function getPrefix(src, method) {
  return src + (method ? ":" + method : "");
}

/**
 * Processes a mark to find an associated finish mark and add a measure of them.
 *
 * Should a finish mark not be found, the `finish` method is run to add one.
 *
 * @private
 *
 * @param {PerformanceEntry} mark - Mark to process
 */
function processMark(mark) {
  var self = this;

  var _mark$split = mark.split("_"),
      _mark$split2 = (0, _slicedToArray3.default)(_mark$split, 1),
      method = _mark$split2[0];

  var markFinish = method + "_finish";

  if (!self.marks.find(function (_ref2) {
    var name = _ref2.name;
    return name.endsWith(markFinish);
  })) {
    console.warn(stringReplace({ string: STRINGS.finish, src: method, type: "finish" }));

    self.finish(method);
  }

  self.measure(method);
}

/**
 * Verifies that each start mark for methods has a matching finish mark
 *
 * @private
 */
function checkMarks() {
  var self = this;

  self.marks.filter(function (_ref3) {
    var name = _ref3.name;
    return name.endsWith("_start");
  }).map(function (entry) {
    return entry.name.split(":")[1];
  }).forEach(processMark.bind(self));
}

function onload() {
  var self = this;
  var src = self.src;

  var finishMark = window.performance.getEntriesByType("mark").find(function (entry) {
    return entry.name === src + "_complete";
  });

  if (!finishMark) {
    console.warn(stringReplace({ string: STRINGS.finish, src: src, type: "complete" }));
    self.finish();
  }

  self.measure();
  checkMarks.call(self);
}

var API = {
  /**
   * Adds a mark to denote the finish of method timing.
   *
   * Should `method` be omitted, default behaviour is to set a mark for the
   * finish of the _source_ timing.
   *
   * @param {string=} method - Name of method that is being timed (optional)
   */
  finish: function finish(method) {
    var self = this;
    var src = self.src;

    var prefix = getPrefix(src, method);
    var name = prefix + "_" + (method ? "finish" : "complete");

    window.performance.mark(name);
    self.marks = self.marks || [];
    self.marks.push(getLatestEntry.call(self, src, "mark"));
  },

  /**
   * Adds a measure denoting the duration of a supplied method.
   *
   * Should `method` be omitted, default behaviour is to set a measure for the _source_.
   *
   * @param {string=} method - Name of method that is being measured (optional)
   */
  measure: function measure(method) {
    var self = this;
    var src = self.src;

    var name = getPrefix(src, method);
    var startName = name + "_" + (method ? "start" : "init");
    var finishName = name + "_" + (method ? "finish" : "complete");

    window.performance.measure(name, startName, finishName);
    self.measures = self.measures || [];
    self.measures.push(getLatestEntry.call(self, src, "measure"));
  },

  /**
   * Runs an optionally supplied function to create a report of marks or measures.
   *
   * Should a `type` value not be specified, a default of `"measures"` is used.
   * Should a function reference not be specified, the debugging will automatically occur.
   *
   * @param {Object=} arg
   * @param {Function=} arg.fn - The function to run (optional)
   * @param {String=} arg.type - The type of entry to report on (optional)
   * @param {Boolean=} arg.debug - Flag denoting if debug information should be written
   *                               into the console (optional)
   */
  report: function report() {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fn = _ref4.fn,
        _ref4$type = _ref4.type,
        type = _ref4$type === undefined ? "measures" : _ref4$type,
        _ref4$debug = _ref4.debug,
        debug = _ref4$debug === undefined ? !fn : _ref4$debug;

    var self = this;

    if (fn) {
      fn(self[type]);
    }

    if (debug) {
      self.debug(type);
    }
  },

  /**
   * Adds a mark to denote the start of method timing.
   *
   * Should `method` be omitted, default behaviour is to set a mark for the start
   * of the _source_ timing.
   *
   * @param {String=} method - Name of method that is being timed (optional)
   */
  start: function start(method) {
    var self = this;
    var src = self.src;

    var prefix = getPrefix(src, method);
    var name = prefix + "_" + (method ? "start" : "init");

    window.performance.mark(name);
    self.marks = self.marks || [];
    self.marks.push(getLatestEntry.call(self, src, "mark"));
  }
};

/**
 * When initialised, an event listener is added to the onload event of `window`
 * and a performance mark is immediately added to set the time of initialisation.
 *
 * Should a `src` value not be specified, a default of`"undefined source"` is used.
 *
 * @param {String=} src - Name of source file / base object (optional)
 */
function UserTiming(_ref5) {
  var src = _ref5.src;

  var self = this;

  self.src = src || "undefined source";

  if (src) {
    window.addEventListener("load", onload.bind(self));
  }

  self.start();
}

var proto = UserTiming.prototype;


(0, _keys2.default)(API).forEach(function (key) {
  (0, _defineProperty2.default)(proto, key, {
    enumerable: true,
    value: API[key]
  });
});

(0, _defineProperties2.default)(proto, {
  debug: {
    value: debugReport
  }
});

exports.default = UserTiming;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(21);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(105), __esModule: true };

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(38);
var TAG = __webpack_require__(10)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(71), __esModule: true };

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initEnquiry = exports.initLoadCountryPhone = exports.formFieldFocusHandler = exports.addInvalidSubmitHandler = exports.resetModal = exports.setCallUsText = exports.setAdditionalInfoPlaceholder = exports.setButtonText = exports.setCountryDropdownVisibility = exports.setTitle = exports.setSubtitle = exports.missingOrInvalidField = exports.handleSubmit = undefined;

var _defineProperty2 = __webpack_require__(13);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(11);

var _extends4 = _interopRequireDefault(_extends3);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _pluralize = __webpack_require__(34);

var _pluralize2 = _interopRequireDefault(_pluralize);

var _dayjs = __webpack_require__(55);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _emarsys = __webpack_require__(63);

var _emarsys2 = _interopRequireDefault(_emarsys);

var _gtm_tracking = __webpack_require__(9);

var _Forms = __webpack_require__(27);

var _Forms2 = _interopRequireDefault(_Forms);

var _DateFormatConsts = __webpack_require__(59);

var _Patterns = __webpack_require__(56);

var _dropdown_phone_code = __webpack_require__(114);

var _dropdown_phone_code2 = _interopRequireDefault(_dropdown_phone_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var submitBooking = function submitBooking(enquiry, data) {
  var form = enquiry.querySelector(".js-booking-form");

  (0, _keys2.default)(data).forEach(function (key) {
    form.querySelector("input[name=" + key + "]").value = data[key];
  });

  form.submit();
};

var trackRemarketing = function trackRemarketing(slug, price) {
  (0, _gtm_tracking.dynamicRemarketing)({
    hrental_id: slug,
    hrental_totalvalue: parseInt(price, 10),
    hrental_pagetype: "conversion"
  });
};

var toggleSubmitButtons = function toggleSubmitButtons(enquiry, active) {
  var enquireButton = enquiry.querySelector(".js-enquiry-submit");
  var bookButton = enquiry.querySelector(".js-booking-submit");

  if (active) {
    enquireButton.removeAttribute("disabled");

    if (bookButton) {
      bookButton.classList.remove("hide");
    }
  } else {
    enquireButton.setAttribute("disabled", "");

    if (bookButton) {
      bookButton.classList.add("hide");
    }
  }
};

var toggleErrorMessages = function toggleErrorMessages(enquiry, active) {
  if (active) {
    enquiry.classList.add("has-failed");
  } else {
    enquiry.classList.remove("has-failed");
  }
};

var handleError = function handleError(form, className, msgError) {
  var element = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "div";

  var fieldSelector = form.querySelector(className);

  if (fieldSelector) {
    fieldSelector.classList.add("is-invalid");
    fieldSelector = fieldSelector.closest(element);
    fieldSelector.querySelector(".fa-exclamation-triangle").classList.remove("hide");
    var htmlErrors = document.createElement("div");
    htmlErrors.classList.add("error-message", "js-error-message");
    htmlErrors.innerText = msgError;
    fieldSelector.after(htmlErrors);
  }
};

var scrollToElement = function scrollToElement(form, className) {
  var scrollToEl = form.querySelector(className);
  if (scrollToEl) {
    var navOffset = 135;
    var topOfElement = window.pageYOffset + scrollToEl.getBoundingClientRect().top - navOffset;
    window.scroll({ top: topOfElement, behavior: "smooth" });
  }
};

var getErrorMessages = function getErrorMessages(enquiry, res, form) {
  var errorsHandled = 0;
  var resErrors = JSON.parse(res.responseText).errors;

  if (resErrors) {
    var keys = (0, _keys2.default)(resErrors);
    var listFieldNameAndParent = {
      email: ["email address"],
      phone: ["phone number", ".layout__item__field"],
      first_name: ["first name"],
      last_name: ["last name"]
    };

    keys.forEach(function (key) {
      var fieldInfo = listFieldNameAndParent[key];

      if (fieldInfo) {
        var convertedKey = ".js-" + key.replace(/_/g, '-') + "-input";

        handleError(form, convertedKey, "Please enter a valid " + fieldInfo[0], fieldInfo[1]);

        errorsHandled += 1;
      }
    });
  }

  scrollToElement(form, ".js-error-message");

  if (errorsHandled === 0) {
    toggleErrorMessages(enquiry, true);
  }

  toggleSubmitButtons(enquiry, true);
};

var postForm = function postForm(enquiry, form, data, callbacks) {
  return function () {
    var firstName = form.querySelector("input[name='enquiry[first_name]']").value;
    var firstNameTitle = firstName.charAt(0).toUpperCase() + firstName.slice(1);
    var slug = window.location.pathname.split("/")[1];
    var enquiryPrice = enquiry.querySelector(".price");
    var price = enquiryPrice ? enquiryPrice.textContent.slice(1) : null;

    $.post(form.action, data).done(function (res) {
      enquiry.querySelector(".js-first-name").textContent = firstNameTitle;
      enquiry.classList.add("has-succeeded");
      var scrollToEl = form.querySelector(".has-succeeded .enquiry__message--success");
      if (scrollToEl) {
        var navOffset = 150;
        // eslint-disable-next-line no-mixed-operators,max-len
        var topOfElement = window.pageYOffset + scrollToEl.getBoundingClientRect().top - navOffset;
        window.scroll({ top: topOfElement, behavior: "smooth" });
      }

      (0, _gtm_tracking.trackEnquiry)(res.gtm_data, res.lead_value);

      if (res.is_booking && res.payment_data.amount) {
        submitBooking(enquiry, res.payment_data);
      } else {
        (0, _emarsys2.default)(res.emarsys_data);
      }

      if (price && slug === "the-masters") {
        trackRemarketing(slug, price);
      }

      if (callbacks.done) {
        callbacks.done();
      }
    }).fail(function (res) {
      getErrorMessages(enquiry, res, form);
      (0, _gtm_tracking.trackServerSideEnquiryError)(form);
    });
  };
};

var handleSubmit = exports.handleSubmit = function handleSubmit(enquiry) {
  var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (e) {
    var form = e.target;
    var formData = $(form).serializeArray();
    e.preventDefault();

    var arrivalDate = formData.find(function (item) {
      return item.name.includes("enquiry[arrival_date]");
    });
    var groupSize = formData.find(function (item) {
      return item.name.includes("enquiry[group_size]");
    });
    var phone = formData.find(function (item) {
      return item.name.includes("enquiry[phone]");
    });
    var isPhoneValid = _Patterns.PHONE_PATTERN.test(phone ? phone.value : "");
    var email = form.querySelector(".js-email-input");
    var isEmailValid = _Patterns.EMAIL_PATTERN.test(email ? email.value : "");
    var firstName = form.querySelector(".js-first-name-input").value;
    var isFirstNameValid = firstName && typeof firstName === 'string';
    var lastName = form.querySelector(".js-last-name-input").value;
    var isLastNameValid = lastName && typeof lastName === 'string';

    if (isPhoneValid && isEmailValid && isLastNameValid && isFirstNameValid && (!groupSize || groupSize.value > "0") && (!arrivalDate || arrivalDate.value.length > 0)) {
      toggleSubmitButtons(enquiry, false);
      toggleErrorMessages(enquiry, false);

      $.getJSON("/csrf-token").done(function (res) {
        return formData.push({ name: res.param, value: res.token });
      }).always(postForm(enquiry, form, formData, callbacks));
    }
  };
};

var missingOrInvalidField = exports.missingOrInvalidField = function missingOrInvalidField(target) {
  var errorPrefix = target.validity.valueMissing ? "Missing" : "Invalid";
  return errorPrefix + " Field: " + target.name;
};

var setSubtitle = exports.setSubtitle = function setSubtitle(enquiry, _ref) {
  var nights = _ref.nights,
      rounds = _ref.rounds,
      date = _ref.date,
      override = _ref.override;

  var subtitle = enquiry.querySelector(".js-enquiry-subtitle");

  if (!subtitle) {
    return;
  }

  if (override) {
    subtitle.textContent = override;

    return;
  }

  var dateObj = (0, _dayjs2.default)(date, _DateFormatConsts.UK_DATE_FORMAT);
  var onDate = dateObj.isValid() ? " on <span class=\"nowrap\">\n        " + dateObj.format(_DateFormatConsts.SUMMARY_DATE_FORMAT_SHORT) + "\n      </span>" : "";
  var nightsAndRounds = { night: nights, round: rounds };
  var subtitleText = (0, _keys2.default)(nightsAndRounds).filter(function (key) {
    return !!nightsAndRounds[key];
  }).map(function (key) {
    return (0, _pluralize2.default)(key, nightsAndRounds[key], true);
  }).join(", ").concat(onDate);

  subtitle.innerHTML = subtitleText;
};

var setTitle = exports.setTitle = function setTitle(enquiry, text) {
  var title = enquiry.querySelector(".js-enquiry-title");
  var dest = enquiry.querySelector(".js-destination");

  if (title && text) {
    title.textContent = text;
  } else if (title && dest) {
    title.textContent = dest.options[dest.selectedIndex].text;
  }
};

var setCountryDropdownVisibility = exports.setCountryDropdownVisibility = function setCountryDropdownVisibility(enquiry, setting) {
  var dropdownElement = enquiry.querySelector(".js-country-dropdown");
  var countrySelect = dropdownElement.querySelector("select");

  if (setting) {
    dropdownElement.style.display = "block";
    countrySelect.removeAttribute("disabled");
  } else {
    dropdownElement.style.display = "none";
    countrySelect.setAttribute("disabled", "disabled");
  }
};

var setButtonText = exports.setButtonText = function setButtonText(enquiry, text) {
  var button = enquiry.querySelector(".js-cta-button");

  if (button && text) {
    button.textContent = text;
  }
};

var setAdditionalInfoPlaceholder = exports.setAdditionalInfoPlaceholder = function setAdditionalInfoPlaceholder(enquiry, placeholder) {
  var textBox = enquiry.querySelector(".js-additional-info");

  if (textBox && placeholder) {
    textBox.placeholder = placeholder;
  }
};

var setCallUsText = exports.setCallUsText = function setCallUsText(enquiry, text) {
  var element = enquiry.querySelector(".js-call-us");

  if (element && text) {
    element.textContent = text;
  }
};

var addErrorMsg = function addErrorMsg(form, msg) {
  var offerSubtitle = form.querySelector(".venue__offer__subtitle");
  var errorMsgTag = form.querySelector(".venue__offer__subtitle-container .js-error-message");
  if (errorMsgTag) {
    errorMsgTag.remove();
  }

  var htmlErrors = document.createElement("div");
  htmlErrors.classList.add("error-message", "js-error-message");
  htmlErrors.innerText = msg;
  offerSubtitle.after(htmlErrors);
};

var handleToggle = function handleToggle(enquiry, toggleSelector) {
  return function (e) {
    if (e.target.closest(toggleSelector)) {
      var date = enquiry.querySelector(".js-arrival-date").value;

      var _map = ["nights", "rounds"].map(function (key) {
        return [].slice.call(enquiry.querySelectorAll(".js-enquiry-" + key)).map(function (node) {
          return node.value;
        }).reduce(function (sum, curr) {
          return sum + parseInt(curr, 10);
        }, 0);
      }),
          _map2 = (0, _slicedToArray3.default)(_map, 2),
          nights = _map2[0],
          rounds = _map2[1];

      e.preventDefault();
      enquiry.classList.toggle("is-shifted");
      enquiry.classList.remove("has-failed");
      setTitle(enquiry);
      setSubtitle(enquiry, { nights: nights, rounds: rounds, date: date });
    }
  };
};

var handleFlightsToggle = function handleFlightsToggle(enquiry, toggleSelector) {
  return function (e) {
    if (e.target.closest(toggleSelector)) {
      enquiry.querySelector(".js-airport-input").classList.toggle("hide", !e.target.checked);
    }
  };
};

var hidePhoneFields = function hidePhoneFields() {
  var phoneFields = document.querySelector(".js-phone-consent");
  if (phoneFields) {
    phoneFields.classList.add("hide");
  }
};

var resetModal = exports.resetModal = function resetModal(enquiry) {
  var modal = enquiry.closest(".modal");

  if (modal) {
    $(modal).on("hidden.bs.modal", function () {
      var enquireButton = enquiry.querySelector(".js-enquiry-submit");
      var bookButton = enquiry.querySelector(".js-booking-submit");
      var defaultCheckedBoxes = enquiry.querySelectorAll(".js-checked-box");
      var defaultUncheckedBoxes = enquiry.querySelectorAll(".js-unchecked-box");

      enquiry.classList.remove("has-failed", "has-succeeded", "is-shifted");
      enquireButton.removeAttribute("disabled");

      defaultCheckedBoxes.forEach(function (checkBox) {
        checkBox.checked = true;
      });
      defaultUncheckedBoxes.forEach(function (checkBox) {
        checkBox.checked = false;
      });
      if (bookButton) bookButton.classList.remove("hide");

      hidePhoneFields();
    });
  }
};

var invalidEnquiryData = function invalidEnquiryData(form) {
  var inputs = [].slice.call(form.getElementsByTagName("input"));
  var formData = inputs.reduce(function (obj, input) {
    return (0, _extends4.default)((0, _defineProperty3.default)({}, input.name, input.value), obj);
  }, {});

  var validationErrors = inputs.filter(function (input) {
    return !input.validity.valid;
  }).map(missingOrInvalidField);

  var breadcrumbs = document.querySelector(".js-breadcrumbs");

  var supplementedFormData = (0, _extends4.default)({}, formData, {
    "enquiry[url]": window.location.href,
    "enquiry[validation_errors]": validationErrors,
    "enquiry[page]": document.title,
    "enquiry[breadcrumbs]": breadcrumbs ? breadcrumbs.innerText : ""
  });

  return supplementedFormData;
};

var validateDate = function validateDate(form) {
  var date = form.querySelector(".js-offer-date");

  return !date || date.value.length > 0; // return true if no date field or field has value
};

var dateFieldValidation = function dateFieldValidation(form) {
  var isDateValid = validateDate(form);

  if (!isDateValid) {
    var container = form.querySelector(".js-offer-date-container");
    if (container) {
      container.classList.add("is-invalid");
    }

    var msgError = 'Please select a date';
    addErrorMsg(form, msgError);
  }
  return isDateValid;
};

var validatePax = function validatePax(form) {
  var pax = form.querySelector(".js-offer-pax");
  var selectedPax = pax ? pax.options[pax.selectedIndex] : 0;
  return !pax || selectedPax.value > 0;
};

var paxFieldValidation = function paxFieldValidation(form) {
  var isPaxValid = validatePax(form);
  if (!isPaxValid) {
    var container = form.querySelector(".js-offer-pax-container");
    if (container) {
      container.classList.add("is-invalid");
    }

    var msgError = 'Select no. of people';
    addErrorMsg(form, msgError);
  }
  return isPaxValid;
};

var removeHtmlTagErrors = function removeHtmlTagErrors(form, className) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "div";

  var selector = form.querySelector(className);

  if (selector) {
    // Remove Html tag errors
    selector.closest(element).querySelectorAll(".js-error-message").forEach(function (e) {
      e.remove();
    });
  }
};

var addInvalidSubmitHandler = exports.addInvalidSubmitHandler = function addInvalidSubmitHandler(form) {
  form.querySelector("[type=submit]").addEventListener("click", function () {
    // Remove tag html errors
    removeHtmlTagErrors(form, ".js-email-input", ".field-group");
    removeHtmlTagErrors(form, ".js-phone-input", ".field-group");
    removeHtmlTagErrors(form, ".js-first-name-input", ".field-group");
    removeHtmlTagErrors(form, ".js-last-name-input", ".field-group");
    removeHtmlTagErrors(form, ".venue__offer__subtitle", ".venue__offer__subtitle-container");

    // Validate first name
    var firstName = form.querySelector(".js-first-name-input");
    firstName = firstName ? firstName.value : "";
    if (firstName === "") {
      handleError(form, ".js-first-name-input", "Please enter a valid first name");
    }

    // Validate last name
    var lastName = form.querySelector(".js-last-name-input");
    lastName = lastName ? lastName.value : "";
    if (lastName === "") {
      handleError(form, ".js-last-name-input", "Please enter a valid last name");
    }

    // Validate email
    var email = form.querySelector(".js-email-input");
    var isEmailValid = _Patterns.EMAIL_PATTERN.test(email ? email.value : "");
    if (!isEmailValid) {
      handleError(form, ".js-email-input", "Please enter a valid email address");
    }

    // Validate phone
    var phone = form.querySelector(".js-phone-input");
    var isPhoneValid = _Patterns.PHONE_PATTERN.test(phone ? phone.value : "");
    if (!isPhoneValid) {
      handleError(form, ".js-phone-input", "Please enter a valid phone number", ".layout__item__field");
    }

    // Validate arrival date
    var isDateValid = dateFieldValidation(form);
    var isPaxValid = paxFieldValidation(form);

    if (!isDateValid && !isPaxValid) {
      var errorMsg = form.querySelector(".js-error-message");
      if (errorMsg) {
        errorMsg.remove();
      }

      var msgError = 'Select no. of people & a date';
      addErrorMsg(form, msgError);
    }
    scrollToElement(form, ".js-error-message");

    scrollToElement(form, ".js-error-message");

    if (isPaxValid && isDateValid && isEmailValid && !form.checkValidity()) {
      var invalidFields = [].slice.call(form.querySelectorAll(":invalid"));
      var phoneFieldValid = !invalidFields.some(function (input) {
        return input.name === "enquiry[phone]";
      });
      var emailFieldValid = !invalidFields.some(function (input) {
        return input.name === "enquiry[email]";
      });

      if (phoneFieldValid || emailFieldValid) {
        var data = (0, _Forms.queryString)(invalidEnquiryData(form));

        fetch("/incomplete_enquiries?" + data, {
          method: "POST"
        });
      }
    }
  });
};

var addDateFocusHandler = function addDateFocusHandler(enquiry) {
  var dateInput = enquiry.querySelector(".js-offer-date");
  if (dateInput) {
    dateInput.addEventListener("focus", function () {
      var dateContainer = enquiry.querySelector(".js-offer-date-container.is-invalid");
      if (dateContainer) {
        dateContainer.classList.remove("is-invalid");
      }
      var errorMsg = enquiry.querySelector(".js-error-message");
      if (errorMsg) {
        errorMsg.remove();
      }
    });
  }
};

var addPaxFocusHandler = function addPaxFocusHandler(enquiry) {
  var paxInput = enquiry.querySelector(".js-offer-pax");
  if (paxInput) {
    paxInput.addEventListener("focus", function () {
      var paxContainer = enquiry.querySelector(".js-offer-pax-container.is-invalid");
      if (paxContainer) {
        paxContainer.classList.remove("is-invalid");
      }
      var errorMsg = enquiry.querySelector(".js-error-message");
      if (errorMsg) {
        errorMsg.remove();
      }
    });
  }
};

var fieldFocusHandler = function fieldFocusHandler(enquiry, className) {
  var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "div";

  var fieldFocus = enquiry.querySelector(className);
  if (fieldFocus) {
    fieldFocus.addEventListener("focus", function () {
      var selectorParentTag = fieldFocus;
      selectorParentTag = selectorParentTag.closest(element);

      var warningTag = selectorParentTag.querySelector(".fa-exclamation-triangle");
      if (warningTag) {
        warningTag.classList.add("hide");
      }

      var errorMsgTag = selectorParentTag.querySelector(".js-error-message");
      if (errorMsgTag) {
        errorMsgTag.remove();
      }
    });
  }
};

var formFieldFocusHandler = exports.formFieldFocusHandler = function formFieldFocusHandler(enquiry) {
  fieldFocusHandler(enquiry, ".js-phone-input", ".field-group");

  fieldFocusHandler(enquiry, ".js-email-input", ".field-group");

  fieldFocusHandler(enquiry, ".js-first-name-input", ".field-group");

  fieldFocusHandler(enquiry, ".js-last-name-input", ".field-group");
};

var initLoadCountryPhone = exports.initLoadCountryPhone = function initLoadCountryPhone(enquiry) {
  var containers = enquiry.querySelectorAll(".js-phone-container");
  if (containers) {
    (0, _dropdown_phone_code2.default)(containers);
  }
};

var initEnquiry = exports.initEnquiry = function initEnquiry(enquiry) {
  var form = enquiry.querySelector(".js-enquiry-form");

  resetModal(enquiry);

  (0, _Forms2.default)(form, { submit: handleSubmit(enquiry) });

  enquiry.addEventListener("click", handleToggle(enquiry, ".js-enquiry-toggle"));

  enquiry.addEventListener("change", handleFlightsToggle(enquiry, ".js-flights-toggle"));

  addDateFocusHandler(enquiry);

  addPaxFocusHandler(enquiry);

  formFieldFocusHandler(enquiry);

  addInvalidSubmitHandler(form);

  initLoadCountryPhone(enquiry);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(108);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(111);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(20);
var ITERATOR = __webpack_require__(10)('iterator');
var Iterators = __webpack_require__(40);
module.exports = __webpack_require__(0).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryString = exports.default = undefined;

var _keys = __webpack_require__(8);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _Patterns = __webpack_require__(56);

var _gtm_tracking = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handleBlur = function handleBlur(e) {
  var input = e.target;


  if (input.matches(".js-trim-email")) {
    input.value = input.value.replace(/\s/g, "");
  }
};

var handleFocus = function handleFocus(e) {
  var input = e.target;


  if (input.matches(".form-control")) {
    input.classList.remove("is-invalid");
  }
};

var handleInput = function handleInput(e) {
  var input = e.target;


  if (input.matches(".js-floating-placeholder")) {
    input.parentElement.classList.toggle("has-input", !!input.value);
  }
};

var handleInvalid = function handleInvalid(e) {
  var input = e.target;


  if (input.matches(".form-control")) {
    e.preventDefault();
    input.classList.add("is-invalid");
    (0, _gtm_tracking.trackInvalidEnquiryForm)(input);
  }
};

function initForm(form) {
  var eventHandlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  (function () {
    if (form) {
      form.setAttribute('novalidate', 'novalidate');
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
        }
      }, false);
    }
  })();

  if (form) {
    var EVENT_HANDLERS = (0, _extends3.default)({
      input: handleInput,
      blur: { handler: handleBlur, useCapture: true },
      invalid: { handler: handleInvalid, useCapture: true },
      focus: { handler: handleFocus, useCapture: true }
    }, eventHandlers);

    (0, _keys2.default)(EVENT_HANDLERS).filter(function (eventName) {
      return EVENT_HANDLERS[eventName];
    }).forEach(function (eventName) {
      var event = EVENT_HANDLERS[eventName];
      var handler = event.handler || event;
      var useCapture = !!event.useCapture;

      form.addEventListener(eventName, handler, useCapture);
    });

    form.querySelectorAll(".js-phone-input").forEach(function (input) {
      input.setAttribute("pattern", _Patterns.PHONE_PATTERN.source);
    });
  }
}

var queryString = function queryString() {
  var formData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _keys2.default)(formData).map(function (key) {
    return key + "=" + encodeURIComponent(formData[key]);
  }).join("&");
};

exports.default = initForm;
exports.queryString = queryString;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(21);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

/* global define */

(function (root, pluralize) {
  /* istanbul ignore else */
  if (true) {
    // Node.
    module.exports = pluralize();
  } else if (typeof define === 'function' && define.amd) {
    // AMD, registers as an anonymous module.
    define(function () {
      return pluralize();
    });
  } else {
    // Browser global.
    root.pluralize = pluralize();
  }
})(this, function () {
  // Rule storage - pluralize and singularize need to be run sequentially,
  // while other rules can be optimized using an object for instant lookups.
  var pluralRules = [];
  var singularRules = [];
  var uncountables = {};
  var irregularPlurals = {};
  var irregularSingles = {};

  /**
   * Sanitize a pluralization rule to a usable regular expression.
   *
   * @param  {(RegExp|string)} rule
   * @return {RegExp}
   */
  function sanitizeRule (rule) {
    if (typeof rule === 'string') {
      return new RegExp('^' + rule + '$', 'i');
    }

    return rule;
  }

  /**
   * Pass in a word token to produce a function that can replicate the case on
   * another word.
   *
   * @param  {string}   word
   * @param  {string}   token
   * @return {Function}
   */
  function restoreCase (word, token) {
    // Tokens are an exact match.
    if (word === token) return token;

    // Lower cased words. E.g. "hello".
    if (word === word.toLowerCase()) return token.toLowerCase();

    // Upper cased words. E.g. "WHISKY".
    if (word === word.toUpperCase()) return token.toUpperCase();

    // Title cased words. E.g. "Title".
    if (word[0] === word[0].toUpperCase()) {
      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
    }

    // Lower cased words. E.g. "test".
    return token.toLowerCase();
  }

  /**
   * Interpolate a regexp string.
   *
   * @param  {string} str
   * @param  {Array}  args
   * @return {string}
   */
  function interpolate (str, args) {
    return str.replace(/\$(\d{1,2})/g, function (match, index) {
      return args[index] || '';
    });
  }

  /**
   * Replace a word using a rule.
   *
   * @param  {string} word
   * @param  {Array}  rule
   * @return {string}
   */
  function replace (word, rule) {
    return word.replace(rule[0], function (match, index) {
      var result = interpolate(rule[1], arguments);

      if (match === '') {
        return restoreCase(word[index - 1], result);
      }

      return restoreCase(match, result);
    });
  }

  /**
   * Sanitize a word by passing in the word and sanitization rules.
   *
   * @param  {string}   token
   * @param  {string}   word
   * @param  {Array}    rules
   * @return {string}
   */
  function sanitizeWord (token, word, rules) {
    // Empty string or doesn't need fixing.
    if (!token.length || uncountables.hasOwnProperty(token)) {
      return word;
    }

    var len = rules.length;

    // Iterate over the sanitization rules and use the first one to match.
    while (len--) {
      var rule = rules[len];

      if (rule[0].test(word)) return replace(word, rule);
    }

    return word;
  }

  /**
   * Replace a word with the updated word.
   *
   * @param  {Object}   replaceMap
   * @param  {Object}   keepMap
   * @param  {Array}    rules
   * @return {Function}
   */
  function replaceWord (replaceMap, keepMap, rules) {
    return function (word) {
      // Get the correct token and case restoration functions.
      var token = word.toLowerCase();

      // Check against the keep object map.
      if (keepMap.hasOwnProperty(token)) {
        return restoreCase(word, token);
      }

      // Check against the replacement map for a direct word replacement.
      if (replaceMap.hasOwnProperty(token)) {
        return restoreCase(word, replaceMap[token]);
      }

      // Run all the rules against the word.
      return sanitizeWord(token, word, rules);
    };
  }

  /**
   * Check if a word is part of the map.
   */
  function checkWord (replaceMap, keepMap, rules, bool) {
    return function (word) {
      var token = word.toLowerCase();

      if (keepMap.hasOwnProperty(token)) return true;
      if (replaceMap.hasOwnProperty(token)) return false;

      return sanitizeWord(token, token, rules) === token;
    };
  }

  /**
   * Pluralize or singularize a word based on the passed in count.
   *
   * @param  {string}  word      The word to pluralize
   * @param  {number}  count     How many of the word exist
   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
   * @return {string}
   */
  function pluralize (word, count, inclusive) {
    var pluralized = count === 1
      ? pluralize.singular(word) : pluralize.plural(word);

    return (inclusive ? count + ' ' : '') + pluralized;
  }

  /**
   * Pluralize a word.
   *
   * @type {Function}
   */
  pluralize.plural = replaceWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Check if a word is plural.
   *
   * @type {Function}
   */
  pluralize.isPlural = checkWord(
    irregularSingles, irregularPlurals, pluralRules
  );

  /**
   * Singularize a word.
   *
   * @type {Function}
   */
  pluralize.singular = replaceWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Check if a word is singular.
   *
   * @type {Function}
   */
  pluralize.isSingular = checkWord(
    irregularPlurals, irregularSingles, singularRules
  );

  /**
   * Add a pluralization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addPluralRule = function (rule, replacement) {
    pluralRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add a singularization rule to the collection.
   *
   * @param {(string|RegExp)} rule
   * @param {string}          replacement
   */
  pluralize.addSingularRule = function (rule, replacement) {
    singularRules.push([sanitizeRule(rule), replacement]);
  };

  /**
   * Add an uncountable word rule.
   *
   * @param {(string|RegExp)} word
   */
  pluralize.addUncountableRule = function (word) {
    if (typeof word === 'string') {
      uncountables[word.toLowerCase()] = true;
      return;
    }

    // Set singular and plural references for the word.
    pluralize.addPluralRule(word, '$0');
    pluralize.addSingularRule(word, '$0');
  };

  /**
   * Add an irregular word definition.
   *
   * @param {string} single
   * @param {string} plural
   */
  pluralize.addIrregularRule = function (single, plural) {
    plural = plural.toLowerCase();
    single = single.toLowerCase();

    irregularSingles[single] = plural;
    irregularPlurals[plural] = single;
  };

  /**
   * Irregular rules.
   */
  [
    // Pronouns.
    ['I', 'we'],
    ['me', 'us'],
    ['he', 'they'],
    ['she', 'they'],
    ['them', 'them'],
    ['myself', 'ourselves'],
    ['yourself', 'yourselves'],
    ['itself', 'themselves'],
    ['herself', 'themselves'],
    ['himself', 'themselves'],
    ['themself', 'themselves'],
    ['is', 'are'],
    ['was', 'were'],
    ['has', 'have'],
    ['this', 'these'],
    ['that', 'those'],
    // Words ending in with a consonant and `o`.
    ['echo', 'echoes'],
    ['dingo', 'dingoes'],
    ['volcano', 'volcanoes'],
    ['tornado', 'tornadoes'],
    ['torpedo', 'torpedoes'],
    // Ends with `us`.
    ['genus', 'genera'],
    ['viscus', 'viscera'],
    // Ends with `ma`.
    ['stigma', 'stigmata'],
    ['stoma', 'stomata'],
    ['dogma', 'dogmata'],
    ['lemma', 'lemmata'],
    ['schema', 'schemata'],
    ['anathema', 'anathemata'],
    // Other irregular rules.
    ['ox', 'oxen'],
    ['axe', 'axes'],
    ['die', 'dice'],
    ['yes', 'yeses'],
    ['foot', 'feet'],
    ['eave', 'eaves'],
    ['goose', 'geese'],
    ['tooth', 'teeth'],
    ['quiz', 'quizzes'],
    ['human', 'humans'],
    ['proof', 'proofs'],
    ['carve', 'carves'],
    ['valve', 'valves'],
    ['looey', 'looies'],
    ['thief', 'thieves'],
    ['groove', 'grooves'],
    ['pickaxe', 'pickaxes'],
    ['passerby', 'passersby']
  ].forEach(function (rule) {
    return pluralize.addIrregularRule(rule[0], rule[1]);
  });

  /**
   * Pluralization rules.
   */
  [
    [/s?$/i, 's'],
    [/[^\u0000-\u007F]$/i, '$0'],
    [/([^aeiou]ese)$/i, '$1'],
    [/(ax|test)is$/i, '$1es'],
    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
    [/(e[mn]u)s?$/i, '$1s'],
    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
    [/(seraph|cherub)(?:im)?$/i, '$1im'],
    [/(her|at|gr)o$/i, '$1oes'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
    [/sis$/i, 'ses'],
    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
    [/([^aeiouy]|qu)y$/i, '$1ies'],
    [/([^ch][ieo][ln])ey$/i, '$1ies'],
    [/(x|ch|ss|sh|zz)$/i, '$1es'],
    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
    [/(pe)(?:rson|ople)$/i, '$1ople'],
    [/(child)(?:ren)?$/i, '$1ren'],
    [/eaux$/i, '$0'],
    [/m[ae]n$/i, 'men'],
    ['thou', 'you']
  ].forEach(function (rule) {
    return pluralize.addPluralRule(rule[0], rule[1]);
  });

  /**
   * Singularization rules.
   */
  [
    [/s$/i, ''],
    [/(ss)$/i, '$1'],
    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
    [/ies$/i, 'y'],
    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
    [/\b(mon|smil)ies$/i, '$1ey'],
    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
    [/(seraph|cherub)im$/i, '$1'],
    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
    [/(test)(?:is|es)$/i, '$1is'],
    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
    [/(alumn|alg|vertebr)ae$/i, '$1a'],
    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
    [/(matr|append)ices$/i, '$1ix'],
    [/(pe)(rson|ople)$/i, '$1rson'],
    [/(child)ren$/i, '$1'],
    [/(eau)x?$/i, '$1'],
    [/men$/i, 'man']
  ].forEach(function (rule) {
    return pluralize.addSingularRule(rule[0], rule[1]);
  });

  /**
   * Uncountable rules.
   */
  [
    // Singular words with no plurals.
    'adulthood',
    'advice',
    'agenda',
    'aid',
    'aircraft',
    'alcohol',
    'ammo',
    'analytics',
    'anime',
    'athletics',
    'audio',
    'bison',
    'blood',
    'bream',
    'buffalo',
    'butter',
    'carp',
    'cash',
    'chassis',
    'chess',
    'clothing',
    'cod',
    'commerce',
    'cooperation',
    'corps',
    'debris',
    'diabetes',
    'digestion',
    'elk',
    'energy',
    'equipment',
    'excretion',
    'expertise',
    'firmware',
    'flounder',
    'fun',
    'gallows',
    'garbage',
    'graffiti',
    'hardware',
    'headquarters',
    'health',
    'herpes',
    'highjinks',
    'homework',
    'housework',
    'information',
    'jeans',
    'justice',
    'kudos',
    'labour',
    'literature',
    'machinery',
    'mackerel',
    'mail',
    'media',
    'mews',
    'moose',
    'music',
    'mud',
    'manga',
    'news',
    'only',
    'personnel',
    'pike',
    'plankton',
    'pliers',
    'police',
    'pollution',
    'premises',
    'rain',
    'research',
    'rice',
    'salmon',
    'scissors',
    'series',
    'sewage',
    'shambles',
    'shrimp',
    'software',
    'species',
    'staff',
    'swine',
    'tennis',
    'traffic',
    'transportation',
    'trout',
    'tuna',
    'wealth',
    'welfare',
    'whiting',
    'wildebeest',
    'wildlife',
    'you',
    /pok[eé]mon$/i,
    // Regexes.
    /[^aeiou]ese$/i, // "chinese", "japanese"
    /deer$/i, // "deer", "reindeer"
    /fish$/i, // "fish", "blowfish", "angelfish"
    /measles$/i,
    /o[iu]s$/i, // "carnivorous"
    /pox$/i, // "chickpox", "smallpox"
    /sheep$/i
  ].forEach(pluralize.addUncountableRule);

  return pluralize;
});


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getEnvironment() {
  var meta = document.querySelector('meta[name="server-environment"]');

  return meta ? meta.getAttribute("content") : undefined;
}

var isDataSaving = function isDataSaving() {
  return document.documentElement.hasAttribute("data-save-data");
};

var isDevelopment = function isDevelopment() {
  return getEnvironment() === 'development';
};

var isProduction = function isProduction() {
  return !isDevelopment();
};

var isStaging = function isStaging() {
  return getEnvironment() === 'staging';
};

exports.getEnvironment = getEnvironment;
exports.isDataSaving = isDataSaving;
exports.isDevelopment = isDevelopment;
exports.isProduction = isProduction;
exports.isStaging = isStaging;

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _remarketing = __webpack_require__(552);

var _remarketing2 = _interopRequireDefault(_remarketing);

var _gtm_tracking = __webpack_require__(9);

var _userTiming = __webpack_require__(126);

var _userTiming2 = _interopRequireDefault(_userTiming);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userTiming = new _userTiming2.default({ src: "remarketing" });

function offerDetail(slug) {
  if (['the-masters', 'the-masters-experience'].indexOf(slug) > -1) {
    (0, _gtm_tracking.dynamicRemarketing)({
      hrental_id: slug,
      hrental_pagetype: 'offerdetail'
    });
  }
}

function remarket() {
  userTiming.start("remarket");

  offerDetail(window.location.pathname.split('/')[1]);
  _remarketing2.default.facebookPixel();

  userTiming.finish("remarket");
}

window.addEventListener("DOMContentLoaded", remarket);

userTiming.finish();

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _facebookPixel = __webpack_require__(553);

var _facebookPixel2 = _interopRequireDefault(_facebookPixel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function loadTrackingScript(_ref) {
  var _ref$init = _ref.init,
      init = _ref$init === undefined ? noop : _ref$init,
      _ref$onload = _ref.onload,
      onload = _ref$onload === undefined ? noop : _ref$onload,
      _ref$preload = _ref.preload,
      preload = _ref$preload === undefined ? noop : _ref$preload,
      _ref$src = _ref.src,
      src = _ref$src === undefined ? "" : _ref$src;

  if (!src) {
    throw new ReferenceError("Script source not provided");
  }

  init();
  preload();

  var _document$getElements = document.getElementsByTagName("script"),
      _document$getElements2 = (0, _slicedToArray3.default)(_document$getElements, 1),
      node = _document$getElements2[0];

  var script = document.createElement("script");

  script.async = true;
  script.src = src;
  script.addEventListener("load", onload);
  node.parentNode.insertBefore(script, node);
}

function facebookPixel() {
  loadTrackingScript(_facebookPixel2.default); // dogfooding
}

exports.default = {
  facebookPixel: facebookPixel,
  loadTrackingScript: loadTrackingScript
};

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var id = "1069363383121935";
var src = "https://connect.facebook.net/en_US/fbevents.js";

function fbqFn() {
  for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
    rest[_key] = arguments[_key];
  }

  if (fbqFn.callMethod) {
    fbqFn.callMethod.apply(fbqFn, rest);
  } else {
    fbqFn.queue.push(rest);
  }
}

function init() {
  if (!window.fbq) {
    fbqFn.loaded = true;
    fbqFn.push = fbqFn;
    fbqFn.queue = [];
    fbqFn.version = "2.0";

    window.fbq = window._fbq = fbqFn;
  }
}

function preload() {
  var _window = window,
      fbq = _window.fbq;


  if (fbq) {
    fbq("init", id);
    fbq("track", "PageView");
  }
}

exports.default = {
  init: init,
  preload: preload,
  src: src
};

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line
var EMAIL_PATTERN = exports.EMAIL_PATTERN = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

var NOISEWORDS_PATTERN = exports.NOISEWORDS_PATTERN = /\b(a(?:nd?|t)?|but|from|[io][fn]|[fn]?or|t(?:h(?:e|is)))\b/ig;

var PHONE_PATTERN = exports.PHONE_PATTERN = /^(?=\D*(?:\d\D*){7,}$)(?:([\d\s+()-])(?!\1{6,}))+$/;

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(90), __esModule: true };

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(4);
var core = __webpack_require__(0);
var fails = __webpack_require__(70);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = __webpack_require__(15);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _environment = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.ScarabQueue = window.ScarabQueue || [];

function emarsys() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(0, _environment.isProduction)() && !(0, _environment.isStaging)()) {
    ScarabQueue.push(['testMode']);
  }

  var category = data.category,
      purchase = data.purchase,
      view = data.view;

  var cart = data.cart || _jsCookie2.default.getJSON('emarsysCartData') || [];
  var inThirtyMinutes = 1 / 48;

  _jsCookie2.default.set('emarsysCartData', cart, {
    expires: inThirtyMinutes,
    samesite: "lax"
  });

  if (view) {
    ScarabQueue.push(['view', view]);
  }

  if (category) {
    ScarabQueue.push(['category', category]);
  }

  if (purchase) {
    _jsCookie2.default.remove('emarsysCartData');
    ScarabQueue.push(['cart', []]);
    ScarabQueue.push(['purchase', purchase]);
  } else {
    ScarabQueue.push(['cart', _jsCookie2.default.getJSON('emarsysCartData')]);
  }

  ScarabQueue.push(['go']);
}

exports.default = emarsys;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pushGa4Event = undefined;

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pushGa4Event = function pushGa4Event(event) {
  var payload = (0, _extends3.default)({}, event, {
    event_type: "GA4Event"
  });
  window.dataLayer = window.dataLayer || [];

  if (payload.ecommerce) window.dataLayer.push({ ecommerce: null }); // Recommended per docs
  window.dataLayer.push(payload);

  // Nullify `event_type` to prevent recursive merge issues on successive data layer
  // pushes from other sources. E.g. a third-party push to the data layer could
  // inadvertently trigger GA4 tags in GTM if this param is still present.
  window.dataLayer.push({ event_type: null });
};

exports.pushGa4Event = pushGa4Event;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(60);

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperties = __webpack_require__(61);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _jsCookie = __webpack_require__(15);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConsentCookie = function () {
  function ConsentCookie(name) {
    (0, _classCallCheck3.default)(this, ConsentCookie);

    if (name !== String(name)) {
      throw new Error("Cookie name has not been specified");
    }

    this.name = name;
  }

  (0, _createClass3.default)(ConsentCookie, [{
    key: "clear",
    value: function clear() {
      _jsCookie2.default.remove(this.name);
    }
  }, {
    key: "get",
    value: function get() {
      return _jsCookie2.default.get(this.name);
    }
  }, {
    key: "set",
    value: function set(value, expires) {
      _jsCookie2.default.set(this.name, value, { expires: expires, sameSite: "Strict" });
    }
  }]);
  return ConsentCookie;
}();

function consentMaker() {
  var permCookie = void 0;
  var sessCookie = void 0;

  var Consent = function () {
    function Consent(permanentCookieName, sessionCookieName) {
      (0, _classCallCheck3.default)(this, Consent);

      permCookie = new ConsentCookie(permanentCookieName);
      sessCookie = new ConsentCookie(sessionCookieName);

      (0, _defineProperties2.default)(this, {
        permanentCookie: {
          get: function get() {
            return permCookie;
          }
        },
        sessionCookie: {
          get: function get() {
            return sessCookie;
          }
        }
      });
    }

    (0, _createClass3.default)(Consent, [{
      key: "get",
      value: function get() {
        var consent = this.permanentCookie.get();

        return {
          consented: consent === "true",
          values: {
            perm: consent,
            sess: this.sessionCookie.get()
          }
        };
      }
    }, {
      key: "set",
      value: function set(value) {
        var type = typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value);

        if (type !== "boolean") {
          throw new Error("Invalid parameter type: " + type + ", expected boolean");
        }

        this.permanentCookie.set(value.toString(), Consent.EXPIRY);
        this.sessionCookie.clear();
      }
    }, {
      key: "setUnknownConsent",
      value: function setUnknownConsent(force) {
        var sessionCookie = this.sessionCookie;


        sessionCookie.clear();
        if (force) {
          sessionCookie.set(Consent.UNKNOWN);
        }
      }
    }, {
      key: "hasSetConsent",
      get: function get() {
        return this.permanentCookie.get() !== undefined;
      }
    }, {
      key: "hasUnknownConsent",
      get: function get() {
        return this.sessionCookie.get() === Consent.UNKNOWN;
      }
    }], [{
      key: "EXPIRY",
      get: function get() {
        return 3600;
      }
    }, {
      key: "UNKNOWN",
      get: function get() {
        return "unknown";
      }
    }]);
    return Consent;
  }();

  return Consent;
}

exports.default = consentMaker();

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(32), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(92), __esModule: true };

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEWS = exports.EVENT_TYPES = exports.DEFAULT_CONSENT = exports.virtualPageView = exports.trackServerSideEnquiryError = exports.trackLastMinuteDeal = exports.trackInvalidEnquiryForm = exports.trackGoal = exports.trackEnquiry = exports.trackClick = exports.pushDataLayer = exports.ga4Event = exports.gaEventNoHit = exports.gaEvent = exports.dynamicRemarketing = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(11);

var _extends3 = _interopRequireDefault(_extends2);

var _Consent = __webpack_require__(66);

var _Consent2 = _interopRequireDefault(_Consent);

var _Enquiries = __webpack_require__(22);

var _ga4_helper = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toSnakeCase = function toSnakeCase(string) {
  return string.replace(/([A-Z]+)/g, "_$1").replace(/^_/, "");
};

var VIEWS = {
  PERSONAL_DETAILS: ["Enquiry, Personal Details", "/enquiries/personal_details"],
  TRAVEL_DETAILS: ["Enquiry, Travel Details", "/enquiries/travel_details"],
  ENQUIRY_COMPLETE: ["Enquiry, Completed", "/enquiries/completed"],
  BOOKING_CUSTOMIZE_OFFER: ["Customize Offer", "/booking/customize-offer"],
  BOOKING_PERSONAL_DETAILS: ["Personal Details", "/booking/personal-details"],
  BOOKING_STRIPE_CHECKOUT: ["Stripe Checkout", "/booking/checkout"],
  BOOKING_COMPLETE: ["Booking Complete", "/booking/complete"]
};

var CONSENT_COOKIES = {
  perm: "permConsent",
  sess: "sessConsent"
};

var DEFAULT_CONSENT = {
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: 'denied'
};

var EVENT_TYPES = {
  DYNAMIC_REMARKETING: 'dynamicRemarketing',
  GA: 'GAEvent',
  GA_NO_HIT: 'GAEventNoHit',
  GA4: 'GA4Event',
  GA4_NO_HIT: 'GA4EventNoHit',
  VIRTUAL_PAGEVIEW: 'VirtualPageview'
};

var GOALS = {
  CLICKED_PACKAGE: ["Search Page", "Clicked Package"],
  CLICKED_DYNAMIC_PACKAGE: ["Dynamic Page", "Clicked Package"],
  VIEWED_DYNAMIC: ["Dynamic Page View", "Success"],
  VIEWED_REGION: ["Region View", "Success"],
  VIEWED_VENUE: ["Venue View", "Success"]
};

var COMMON_METRICS = ["goal", "ecommerce", "remarketing"];

var consent = new _Consent2.default(CONSENT_COOKIES.perm, CONSENT_COOKIES.sess);

var lastVisibilityChange = void 0;

var pushDataLayer = function pushDataLayer(payload) {
  if (!payload) {
    return;
  }

  window.dataLayer.push(payload);
};

var pushGAEvent = function pushGAEvent(event, payload) {
  if (!payload.eventCategory || !payload.eventAction) {
    return;
  }

  pushDataLayer((0, _extends3.default)({ event: event }, payload));
};

var dynamicRemarketing = function dynamicRemarketing(remarketingData) {
  if (consent.get().consented) {
    pushDataLayer({ event: EVENT_TYPES.DYNAMIC_REMARKETING, remarketingData: remarketingData });
  }
};

var trackCommonMetrics = function trackCommonMetrics(data) {
  var commonMetrics = consent.get().consented ? COMMON_METRICS : COMMON_METRICS.filter(function (metric) {
    return metric !== "remarketing";
  });

  commonMetrics.forEach(function (metric) {
    return pushDataLayer(data[metric]);
  });
};

var gaEvent = function gaEvent(eventCategory, eventAction, eventLabel) {
  pushGAEvent(EVENT_TYPES.GA, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
  pushGAEvent(EVENT_TYPES.GA4, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
};

var gaEventNoHit = function gaEventNoHit(eventCategory, eventAction, eventLabel) {
  pushGAEvent(EVENT_TYPES.GA_NO_HIT, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
  pushGAEvent(EVENT_TYPES.GA4_NO_HIT, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
};

var ga4Event = function ga4Event(eventCategory, eventAction, eventLabel) {
  pushGAEvent(EVENT_TYPES.GA4, { eventCategory: eventCategory, eventAction: eventAction, eventLabel: eventLabel });
};

var virtualPageView = function virtualPageView(pageView) {
  var view = VIEWS[pageView] || VIEWS[toSnakeCase(pageView).toUpperCase()];
  var event = EVENT_TYPES.VIRTUAL_PAGEVIEW;

  if (!view) {
    throw new ReferenceError(event + ": \"" + pageView + "\" not found");
  }

  var _view = (0, _slicedToArray3.default)(view, 2),
      virtualPageTitle = _view[0],
      virtualPageURL = _view[1];

  pushDataLayer({ event: event, virtualPageTitle: virtualPageTitle, virtualPageURL: virtualPageURL });
};

var trackGoal = function trackGoal(goalName) {
  var goal = GOALS[goalName];

  if (!goal) {
    return;
  }

  var _goal = (0, _slicedToArray3.default)(goal, 2),
      action = _goal[0],
      label = _goal[1];

  gaEvent("Goals", action, label);
};

var trackEnquiry = function trackEnquiry(gtmData, leadValue) {
  trackCommonMetrics(gtmData);
  virtualPageView("ENQUIRY_COMPLETE");
  (0, _ga4_helper.pushGa4Event)({
    event: "generate_lead",
    lead_type: "Enquiry",
    lead_value: leadValue
  });
};

var trackLastMinuteDeal = function trackLastMinuteDeal(data) {
  trackCommonMetrics(data);
  virtualPageView("BOOKING_COMPLETE");
};

var trackClick = function trackClick(target) {
  var _target$dataset = target.dataset,
      gtmCategory = _target$dataset.gtmCategory,
      gtmAction = _target$dataset.gtmAction,
      gtmLabel = _target$dataset.gtmLabel,
      gtmPageview = _target$dataset.gtmPageview;


  if (gtmCategory) {
    gaEvent(gtmCategory, gtmAction, gtmLabel || target.href);
  }

  if (gtmPageview) {
    virtualPageView(gtmPageview);
  }
};

var trackInvalidEnquiryForm = function trackInvalidEnquiryForm(target) {
  var formType = target.form.dataset.gtmFormType || "Enquiry Form";

  gaEventNoHit("Failed Enquiry", formType, (0, _Enquiries.missingOrInvalidField)(target));
};

var trackServerSideEnquiryError = function trackServerSideEnquiryError(target) {
  var trackedError = "Failed enquiry: 422 error";
  var formType = target.dataset.gtmFormType || "Enquiry Form";

  gaEventNoHit("Failed Enquiry", formType, trackedError);
};

var trackVisibilityState = function trackVisibilityState() {
  var now = new Date().getTime();
  var _window = window,
      dataLayer = _window.dataLayer;

  var state = document.visibilityState;

  if (!lastVisibilityChange) {
    var GTM_START = "gtm.start";
    var start = dataLayer.find(function (entry) {
      return entry && entry[GTM_START];
    });

    lastVisibilityChange = start ? start[GTM_START] : now - 1;
  } else {
    state = state === "hidden" ? "visible" : "hidden";
  }

  var diff = now - lastVisibilityChange;

  if (diff) {
    pushGAEvent(EVENT_TYPES.GA_NO_HIT, {
      eventCategory: "Page Visibility",
      eventAction: state,
      eventLabel: location.pathname,
      eventValue: diff
    });
  }

  lastVisibilityChange = now;
};

var trackTotalVisibility = function trackTotalVisibility(visible) {
  var eventAction = visible ? "visible" : "hidden";
  var eventCategory = "Total Page " + (visible ? "Visibility" : "Invisibility");
  var total = window.dataLayer.filter(Boolean).filter(function (entry) {
    return entry.eventCategory === "Page Visibility" && entry.eventAction === eventAction;
  }).reduce(function (acc, entry) {
    return acc + entry.eventValue;
  }, 0);

  pushGAEvent(EVENT_TYPES.GA_NO_HIT, {
    eventCategory: eventCategory,
    eventAction: "Page Unload",
    eventLabel: location.pathname,
    eventValue: Math.min(total, 30 * 60 * 1e3)
  });
};

window.dataLayer = window.dataLayer || [];

window.addEventListener("load", trackVisibilityState);
window.addEventListener("beforeunload", function () {
  trackVisibilityState();
  trackTotalVisibility(true);
  trackTotalVisibility();
});

document.addEventListener("visibilitychange", trackVisibilityState);

exports.dynamicRemarketing = dynamicRemarketing;
exports.gaEvent = gaEvent;
exports.gaEventNoHit = gaEventNoHit;
exports.ga4Event = ga4Event;
exports.pushDataLayer = pushDataLayer;
exports.trackClick = trackClick;
exports.trackEnquiry = trackEnquiry;
exports.trackGoal = trackGoal;
exports.trackInvalidEnquiryForm = trackInvalidEnquiryForm;
exports.trackLastMinuteDeal = trackLastMinuteDeal;
exports.trackServerSideEnquiryError = trackServerSideEnquiryError;
exports.virtualPageView = virtualPageView;
exports.DEFAULT_CONSENT = DEFAULT_CONSENT;
exports.EVENT_TYPES = EVENT_TYPES;
exports.VIEWS = VIEWS;

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(91);
var $Object = __webpack_require__(0).Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};


/***/ }),

/***/ 91:
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(4);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(32), 'Object', { defineProperties: __webpack_require__(162) });


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(93);
module.exports = __webpack_require__(0).Object.keys;


/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(30);
var $keys = __webpack_require__(69);

__webpack_require__(62)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ })

},[551]);


// WEBPACK FOOTER //
// remarketing.5d42de76cb775e4804c8.js